import React from 'react'
import { RadBox } from '../common/RadBox'
import { RadButton } from '../common/RadButton'
import { RadContainer } from '../common/RadContainer'
import { RadCopyToClipboard } from '../common/RadCopyToClipboard'
import { RadDivider } from '../common/RadDivider'
import { RadGrid } from '../common/RadGrid'
import { RadLink } from '../common/RadLink'
import { RadSpaceBetween } from '../common/RadSpaceBetween'
import { formatDate } from '../common/utilities'

export function ProjectDetailContent ({ project, setSelectedEntity }) {
  if (project != null) {
    return (
      <RadSpaceBetween size='l'>

        <div>
          <RadBox variant='awsui-key-label' display='inline'>
            SECTOR(S):
          </RadBox>
          <RadBox variant='span' padding={{ left: 'xs' }}>
            {project.sectors.map(x => x.sector?.name ?? x.name).join(', ') || '-'}
          </RadBox>
        </div>

        <RadGrid
          gridDefinition={[
            { colspan: { default: 12, xs: 8 } },
            { colspan: { default: 12, xs: 4 } }
          ]}
        >
          <RadSpaceBetween size='s'>
            <RadBox>{project.description}</RadBox>

            <div>
              <RadBox variant='h2'>
                Project Highlights
              </RadBox>
              <RadSpaceBetween size='s'>
                {(project.deliverables ?? '').split('\n').map(x => <RadBox key={x}>{x}</RadBox>) ?? '-'}
              </RadSpaceBetween>
            </div>

            <br />

            <RadCopyToClipboard
              copyButtonText='Copy link'
              copyErrorText='Link failed to copy'
              copySuccessText='Link copied'
              textToCopy={`${window.location.origin}/project/${project.id}`}
            />

            <div />

            <div>
              <RadDivider className='light-green' />
              <RadBox variant='awsui-key-label'>
                Resources
              </RadBox>
              <div>{project.resources?.length > 0
                ? project.resources.map((x) =>
                  <div key={x.id}>
                    {setSelectedEntity == null && <RadLink href={`/resource/${x.resource.id}`}>{x.resource?.title}</RadLink>}
                    {setSelectedEntity != null &&
                      <RadButton
                        onClick={() => setSelectedEntity({ type: 'resource', id: x.resource.id })}
                        className='font-weight-400'
                        variant='inline-link'
                      >
                        {x.resource?.title}
                      </RadButton>}
                  </div>)
                : '-'}
              </div>
            </div>
          </RadSpaceBetween>

          <RadContainer className='gray-background'>
            <RadSpaceBetween size='s'>
              <RadBox variant='h3'>
                Project Details
              </RadBox>

              <div>
                <RadBox variant='awsui-key-label'>
                  Funding Program
                </RadBox>
                <div>{project.dashFundingProgram?.name ?? '-'}</div>
              </div>

              <div>
                <RadBox variant='awsui-key-label'>
                  Funding Start Date
                </RadBox>
                <div>{project.startDate != null ? formatDate(project.startDate) : '-'}</div>
              </div>

              <div>
                <RadBox variant='awsui-key-label'>
                  Funding End Date
                </RadBox>
                <div>{project.endDate != null ? formatDate(project.endDate) : '-'}</div>
              </div>

              {
                project.contacts != null &&
                  <div>
                    <RadSpaceBetween size='xxs'>
                      <RadBox variant='awsui-key-label'>
                        Contacts
                      </RadBox>
                      {project.contacts.length > 0
                        ? project.contacts.map((x) => <div key={x.id}>{x.name}</div>)
                        : '-'}
                    </RadSpaceBetween>
                  </div>
              }

              <div>
                <RadBox variant='awsui-key-label'>
                  Organizations
                </RadBox>
                <div>{project.organizations?.length > 0
                  ? project.organizations.map((x) =>
                    <div key={x.id}>
                      {setSelectedEntity == null && <RadLink href={`/organization/${x.organization.id}`}>{x.organization?.name}</RadLink>}
                      {setSelectedEntity != null &&
                        <RadButton
                          onClick={() => setSelectedEntity({ type: 'organization', id: x.organization.id })}
                          className='font-weight-400'
                          variant='inline-link'
                        >
                          {x.organization?.name}
                        </RadButton>}
                    </div>
                  )
                  : '-'}
                </div>
              </div>

              <div>
                <RadBox variant='awsui-key-label'>
                  Priority Areas
                </RadBox>
                <div>{project.targetAreas?.length > 0 ? project.targetAreas.map((x) => <div key={x.id}>{x.targetArea.name}</div>) : '-'}</div>
              </div>

              <div>
                <RadBox variant='awsui-key-label'>
                  Priority Populations
                </RadBox>
                <div>{project.targetPopulations?.length > 0 ? project.targetPopulations.map((x) => <div key={x.id}>{x.targetPopulation.name}</div>) : '-'}</div>
              </div>

              <div>
                <RadBox variant='awsui-key-label'>
                  Project Types
                </RadBox>
                <div>{project.useCases?.length > 0 ? project.useCases.map((x) => <div key={x.id}>{x.useCase?.name}</div>) : '-'}</div>
              </div>

              <div>
                <RadBox variant='awsui-key-label'>
                  Collaboratives
                </RadBox>
                <div>{project.collaboratives?.length > 0
                  ? project.collaboratives.map((x) =>
                    <div key={'collaborative-' + x.id}>
                      {setSelectedEntity == null && <RadLink href={`/collaborative/${x.collaborative.id}`}>{x.collaborative.name}</RadLink>}
                      {setSelectedEntity != null &&
                        <RadButton
                          onClick={() => setSelectedEntity({ type: 'collaborative', id: x.collaborative.id })}
                          className='font-weight-400'
                          variant='inline-link'
                        >
                          {x.collaborative?.name}
                        </RadButton>}
                    </div>
                  )
                  : '-'}
                </div>
              </div>

              <div>
                <RadBox variant='awsui-key-label'>
                  Framework Tags
                </RadBox>
                {project.tags.map(x => x.tag.name).join(', ') || '-'}
              </div>
            </RadSpaceBetween>
          </RadContainer>
        </RadGrid>

      </RadSpaceBetween>
    )
  }
}
